<script setup lang="ts">
import { ref, onUnmounted } from 'vue';
import { useStation } from '@/store/station';
import { useLoadingOverlay } from '@/store/overlays/loading-overlay';
import { useChargeManagement } from '@/store/charge-management';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const station = useStation();
const loading_overlay = useLoadingOverlay();
const charge_management = useChargeManagement();

const emit = defineEmits<{ toggle: [] }>();

const pending = ref<boolean>(false);
const button_enabled = ref<boolean>(true);
const display_sheet = ref<boolean>(true);

async function handle_start_charge_click(): Promise<void> {
  if (station.qrcode === null) {
    return;
  }
  if (button_enabled) {
    pending.value = true;
    try {
      button_enabled.value = false;
      loading_overlay.show();
      await charge_management.do_start_charge();
      console.log("[confirmation]: charge started");
    } catch (error) {
      console.log("[confirmation]: error encountered while starting the charge");
    } finally {
      pending.value = false;  // WARN: here?
    }
    await station.do_fetch(station.qrcode, true);
    emit("toggle");
    loading_overlay.hide();
    button_enabled.value = true;
  }
}

import plug_url from '@/assets/plug.png';
onUnmounted(() => button_enabled.value = true);
</script>

<template>
  <!-- <v-overlay -->
  <!--   v-model="display_sheet" -->
  <!--   persistent -->
  <!--   no-click-animation -->
  <!--   z-index="2001" -->
  <!--   style="background-color: rgba(0, 0, 0, 0.4);" -->
  <!-- > -->
    <v-bottom-sheet
      inset
      v-model="display_sheet"
      persistent
      no-click-animation
      z-index="2001"
    >
      <v-sheet class="pa-2">
        <v-container class="ma-0 pa-0 ">
          <v-row
            class="pb-n2 pt-3 text-uppercase subtitle-1 font-weight-bold text-secondary justify-center text-wrap"
          >
            <v-col class="d-flex justify-center align-center pa-1">
              <v-img width="80%" max-width="380px" :src="plug_url" />
            </v-col>
          </v-row>
          <v-row class="justify-center mb-3">
            <v-col class="d-flex justify-center align-center pa-1">
              <span class="text-uppercase subtitle-1 font-weight-bold text-secondary">
                {{ t("is_cable_plugged_in") }}
              </span>
            </v-col>
          </v-row>
          <v-row class="justify-center mb-2">
            <v-col class="d-flex justify-center align-center pa-1">
              <v-btn
                class="bg-success text-button font-weight-bold mr-2"
                size="x-large"
                :text="t('yes')"
                :loading="pending"
                @click.stop="handle_start_charge_click"
              />
              <v-btn
                class="bg-error text-button font-weight-bold ml-2"
                size="x-large"
                :text="t('no')"
                @click="emit('toggle')"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  <!-- </v-overlay> -->
</template>

<i18n lang="yml">
en:
  is_cable_plugged_in: Did you plug in your cable?
  yes: Yes
  no: No
it:
  is_cable_plugged_in: Avete connesso il cavo alla vostra auto?
  yes: Si
  no: No
fr:
  is_cable_plugged_in: Avez-vous branché votre câble ?
  yes: Oui
  no: Non
de:
  is_cable_plugged_in: Hast du den Kabel an dein Auto angeschlossen?
  yes: Ja
  no: Nein
nl:
  is_cable_plugged_in: Is uw kabel aangesloten?
  yes: Ja
  no: Nee
</i18n>

<style scoped lang="scss">
</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
